import React from "react";

const NotFound = () => {
  return (
    <h1
      style={{
        textAlign: "center",
        color: "#fff",
        paddingTop: "40%",
      }}
    >
      404: Not Found
    </h1>
  );
};

export default NotFound;
